'use strict';

// Utils
import matchJS from './utils/matchJS';
import { initReact } from './utils/initReact';
import reloadCachedPage from './utils/reloadCachedPage';

// Routes
import common from './routes/common';
import appHome from './routes/app/appHome';
import confirmEmail from './routes/app/confirmEmail';
import appAccessCode from './routes/app/appAccessCode';
import challengesIndex from './routes/challenges';
import challengesSearch from './routes/challenges/search';
import challengesShow from './routes/challenges/show';
import challengesCreate from './routes/challenges/create';
import challengesEdit from './routes/challenges/edit';
import challengesGallery from './routes/challenges/gallery';
import challengesMaterials from './routes/challenges/materials';
import register from './routes/register/register';
import myUnity from './routes/unities/myUnity';
import challenge3 from './routes/unities/challenge3';
import challenge4 from './routes/unities/challenge4';
import registerShowRegistrationForm from './routes/register/registerShowRegistrationForm';
import profilesCover from './routes/profiles/profilesCover';
import profilesState from './routes/profiles/profilesState';
import profilesRede from './routes/profiles/profilesRede';
import profilesTeam from './routes/profiles/profilesTeam';
import profilesPersonal from './routes/profiles/personal';
import profilesContact from './routes/profiles/contact';
import profilesPassword from './routes/profiles/password';
import { profilesTerms } from './routes/profiles/terms';
import showLoginForm from './routes/login/showLoginForm';
import teamsIndex from './routes/teams/teamsIndex';
import teamsMine from './routes/teams/teamsMine';
import teamsLightning from './routes/teams/lightning';
import teamsChallenge from './routes/teams/challenge';
import teamsRegister from './routes/teams/register';
import teamsValidation from './routes/teams/validation';
import presences from './routes/presences/presences';
import presencesIndex from './routes/presences/presencesIndex';
import presencesDonations from './routes/presences/presencesDonations';
import presencesGallery from './routes/presences/gallery';
import presencesDocuments from './routes/presences/documents';
import presencesActivities from './routes/presences/activities';
import presencesSavedReport from './routes/presences/presencesSavedreport';
import presencesTerms from './routes/presences/terms';
import { hours } from './routes/presences/hours';
import { benefiteds } from './routes/presences/benefiteds';
import faqs from './routes/faqs/faqs';
import forgotPassword from './routes/forgotPassword/forgotPassword';
import habilitiesIndex from './routes/habilities/habilitiesIndex';
import ongsCreate from './routes/ongs/ongsCreate';
import quizIndex from './routes/quiz/quizIndex';
import showResetForm from './routes/resetpassword/showResetForm';
import subscribesShow from './routes/subscribes/show';
import { ranking } from './routes/ranking';

import { stepOne } from './routes/app/stepOne';
import { stepTwo } from './routes/app/stepTwo';
import { stepThree } from './routes/app/stepThree';
import { stepFour } from './routes/app/stepFour';
import { stepFive } from './routes/app/stepFive';
import { lightningOne } from './routes/app/lightningOne';
import { lightningTwo } from './routes/app/lightningTwo';

// React
import Materials from './routes/materials';

var APP = {
  common: {
    init() {
      common.init();
    },
  },

  app: {
    index() {
      appHome.init();
    },

    accessCode() {
      appAccessCode.init();
    },

    stepOne() {
      stepOne();
    },

    stepTwo() {
      stepTwo();
    },

    stepThree() {
      stepThree();
    },

    stepFour() {
      stepFour();
    },

    stepFive() {
      stepFive();
    },

    stepLightningOne() {
      lightningOne();
    },

    stepLightningTwo() {
      lightningTwo();
    },

    confirmEmail() {
      confirmEmail();
    },
  },

  register: {
    init() {
      register.init();
      appAccessCode.init();
    },

    showRegistrationForm() {
      registerShowRegistrationForm.init();
    },
  },

  resetpassword: {
    showResetForm() {
      showResetForm.init();
    },
  },

  login: {
    login() {
      appAccessCode.init();
    },

    showLoginForm() {
      showLoginForm();
    },
  },

  profiles: {
    cover() {
      profilesCover.init();
    },

    password() {
      profilesPassword.init();
    },

    state() {
      profilesState.init();
    },

    rede() {
      profilesRede.init();
    },

    team() {
      profilesTeam.init();
    },

    personal() {
      profilesPersonal.init();
    },

    contact() {
      profilesContact.init();
    },

    terms() {
      profilesTerms();
    },
  },

  teams: {
    index() {
      teamsIndex.init();
    },

    search() {
      teamsIndex.init();
    },

    mine() {
      teamsMine.init();
    },

    lightning0() {
      teamsMine.init();
    },

    lightning() {
      teamsLightning.init();
    },

    challenge() {
      teamsChallenge.init();
    },

    register() {
      teamsRegister.init();
    },

    validation() {
      teamsValidation.init();
    },
  },

  challenges: {
    index() {
      challengesIndex.init();
    },

    search() {
      challengesSearch.init();
    },

    create() {
      challengesCreate.init();
    },

    edit() {
      challengesEdit.init();
    },

    show() {
      challengesShow.init();
    },

    gallery() {
      challengesGallery.init();
    },

    materials() {
      challengesMaterials.init();
    },

    mine() {
      reloadCachedPage();
    },
  },

  materials: {
    index() {
      initReact(document.getElementById('app'), Materials);
    },
  },

  reports: {
    index() {
      reloadCachedPage();
    },
  },

  presences: {
    init() {
      presences.init();
      reloadCachedPage();
    },

    donations() {
      presencesDonations.init();
    },

    index() {
      presencesIndex.init();
    },

    gallery() {
      presencesGallery.init();
    },

    savedreport() {
      presencesSavedReport.init();
    },

    documents() {
      presencesDocuments.init();
    },

    terms() {
      presencesTerms.init();
    },

    hours() {
      hours();
    },

    benefiteds() {
      benefiteds();
    },
  },

  reportactivities: {
    index() {
      presencesActivities.init();
    },
  },

  ranking: {
    index() {
      ranking();
    },
  },

  faqs: {
    init() {
      faqs.init();
    },
  },

  forgotpassword: {
    init() {
      forgotPassword.init();
    },
  },

  habilities: {
    index() {
      habilitiesIndex.init();
    },
  },

  quiz: {
    index() {
      quizIndex.init();
    },
  },

  unities: {
    common() {
      myUnity.modalInvite();
      myUnity.closedMission();
      myUnity.search();
    },
    index() {
      myUnity.init();
    },
    challenge3() {
      challenge3.sendVideo();
    },
    challenge4() {
      challenge4.sendStory();
    },
  },

  ongs: {
    create: () => {
      ongsCreate.init();
    },
  },

  subscribes: {
    show() {
      subscribesShow.init();
    },
  },
};

document.addEventListener('DOMContentLoaded', matchJS.init(APP));
